import { Component } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'logpn-no-result',
  templateUrl: './no-result.component.html',
  styleUrl: './no-result.component.scss',
  imports: [IconComponent, TranslocoPipe],
})
export class NoResultComponent {}
